var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-list" },
    [
      _vm.migrateUser
        ? _c(
            "light-box",
            {
              staticClass: "migrate-popup",
              on: { close: _vm.onCloseMigration }
            },
            [
              _c(
                "div",
                {
                  staticClass: "container",
                  attrs: { slot: "light-box-content" },
                  slot: "light-box-content"
                },
                [
                  _c("sqwiz-migration", {
                    attrs: { "user-id": _vm.migrateUser },
                    on: { close: _vm.onCloseMigration }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "pagination-navigation",
        {
          staticClass: "p-0 p-md-3",
          attrs: { paginationInfo: _vm.getPaginationInfo },
          on: { prevpage: _vm.prevPage, nextpage: _vm.nextPage }
        },
        [
          _c(
            "div",
            { attrs: { slot: "filterSlot" }, slot: "filterSlot" },
            [
              _c("input-text", {
                attrs: {
                  iconRight: "search",
                  small: "",
                  regular: "",
                  variant: "standardInput",
                  inputPlaceholder: _vm.$t("Administration.userList.findUser"),
                  inputName: "query"
                },
                on: { fieldUpdate: _vm.updateFilter }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "users" },
        [
          _c("user-table", { attrs: { userList: _vm.getUserList } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center m-3" },
            [
              _vm.$apollo.loading
                ? _c("q-icon", {
                    attrs: {
                      allowSelfUpdate: false,
                      spin: "",
                      width: "110px",
                      name: "spinner"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination-navigation", {
        staticClass: "p-0 p-md-3",
        attrs: { paginationInfo: _vm.getPaginationInfo },
        on: { prevpage: _vm.prevPage, nextpage: _vm.nextPage }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47338832", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47338832","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/administration/users/UserList.vue
// module id = null
// module chunks = 